import { Grid } from '@mui/material';
import { ChartBox, SlideParagraph, SlideTitle } from 'features/slides';
import { PortfolioStatisticsLineChart } from 'pages/Cases/components/PortfolioStatisticsLineChart';
import { portfolioStatisticsChartFilter } from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type RollingThreeYearReturnsAndExcessReturnsProps = {
  readonly filteredPerformance: any;
};

export function RollingThreeYearReturnsAndExcessReturns({
  filteredPerformance,
}: RollingThreeYearReturnsAndExcessReturnsProps): React.ReactElement {
  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Rolling 3-Year Returns and Excess Returns</SlideTitle>
      </Grid>
      <ChartBox>
        <PortfolioStatisticsLineChart
          data={portfolioStatisticsChartFilter({
            filteredPerformance,
            name: 'rolling_three_year_stats',
            subName: '3_year_rolling_returns',
          })}
          formatChart={{
            unit: '%',
            decimals: 2,
            prefix: '',
            value: 'Return',
            label: 'Return (%)',
          }}
          height={250}
          isWithAnimation={false}
          showLegend={false}
        />
      </ChartBox>

      <ChartBox>
        <PortfolioStatisticsLineChart
          data={portfolioStatisticsChartFilter({
            filteredPerformance,
            name: 'rolling_three_year_stats',
            subName: '3_year_excess_returns',
          })}
          formatChart={{
            unit: '%',
            decimals: 2,
            prefix: '',
            value: 'Excess Return',
            label: 'Excess Return (%)',
          }}
          height={250}
          isWithAnimation={false}
        />
      </ChartBox>
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
